import { Link } from 'gatsby'
import React, { ReactElement, ReactNode } from 'react'
import { ThemeUIStyleObject, Text } from 'theme-ui'

const linkStyles = {
  textDecoration: 'underline',
  color: 'greenApple',
}

export default function StyledLink({
  children,
  to,
  sx,
}: {
  children: ReactNode
  to: string
  sx?: ThemeUIStyleObject
}): ReactElement {
  return (
    <Link to={to}>
      <Text sx={{ ...linkStyles, ...sx }}>{children}</Text>
    </Link>
  )
}
